import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Spinner } from '@chakra-ui/react';
import { PageBox } from '../../../components/pageBox';
import { PageHeader } from '../../../components/PageHeader';
import { ReturnButton } from '../../../components/buttons/ReturnButton';
import { IDataNoPagination } from '../../../types/shared';
import { IGroup, useGroups } from '../../../hooks/useGroups';
import GroupsForm from '../../../components/forms/GroupsForm';

export default function GroupsEditPage() {
  const { getGroup } = useGroups();
  const { itemId } = useParams();

  const {
    data,
    isLoading: loadingData,
    isError,
  } = useQuery<IDataNoPagination<IGroup>>({
    queryFn: getGroup,
    queryKey: ['getGroup', { groupId: itemId }],
  });

  return (
    <PageBox>
      <div className="flex flex-col gap-2">
        <ReturnButton previousPage="configuracoes/grupos" label="Voltar para Grupos" />
        <PageHeader title="Editar grupo" />
        {loadingData ? (
          <div className="flex flex-col items-center gap-4">
            <Spinner size="lg" color="primary" />
            <span className="text-xl font-semibold">Carregando...</span>
          </div>
        ) : (
          <GroupsForm
            defaultValues={isError ? undefined : (data as IDataNoPagination<IGroup>).data}
          />
        )}
      </div>
    </PageBox>
  );
}
